module.exports = __webpack_public_path__ + "img/watchlist.50e3a165.svg";